// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginPage_form__i5E3_"};